import * as actionTypes from "../action-types";
import { put, takeLeading } from 'redux-saga/effects';
import { getAPI } from '../../utils/api-function';
import { get_reports, get_site_settings, get_awards, get_media_coverage, get_videos, get_blogs, get_blog_by_id, get_community_members } from '../../utils/api-routes';

function* getReports() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_reports);
        console.log("Get Reports Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_REPORTS, payload: data?.result });
        } else {
            yield put({ type: actionTypes.SET_REPORTS, payload: '' });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Reports Saga Error ::: ", error);
    }
};

function* getSiteSettings() {
    try {
        const { data } = yield getAPI(get_site_settings);
        if (data?.status) {
            yield put({ type: actionTypes.SET_SITE_SETTINGS, payload: data?.result });
        } else {
            yield put({ type: actionTypes.SET_SITE_SETTINGS, payload: null });
        }
    } catch (error) {
        console.log("Get Site Settings Saga Error ::: ", error);
    }
};

function* getAwards() {
    try {
        const { data } = yield getAPI(get_awards);
        if (data?.status) {
            yield put({ type: actionTypes.SET_AWARDS, payload: data?.result });
        } else {
            yield put({ type: actionTypes.SET_AWARDS, payload: [] });
        }
    } catch (error) {
        console.log("Get Awards Saga Error ::: ", error);
    }
};

function* getMediaCoverage() {
    try {
        const { data } = yield getAPI(get_media_coverage);
        if (data?.status) {
            yield put({ type: actionTypes.SET_MEDIA_COVERAGE, payload: data?.result });
        } else {
            yield put({ type: actionTypes.SET_MEDIA_COVERAGE, payload: [] });
        }
    } catch (error) {
        console.log("Get Media Coverage Saga Error ::: ", error);
    }
};

function* getTestimonialVideos() {
    try {
        const { data } = yield getAPI(get_videos + '?type=Testimonial');
        if (data?.status) {
            yield put({ type: actionTypes.SET_TESTIMONIAL_VIDEOS, payload: data?.result });
        } else {
            yield put({ type: actionTypes.SET_TESTIMONIAL_VIDEOS, payload: [] });
        }
    } catch (error) {
        console.log("Get Testimonial Videos Saga Error ::: ", error);
    }
};

function* getBlogs() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield getAPI(get_blogs);
        console.log("Get Blogs Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_BLOGS, payload: data?.result });
        } else {
            yield put({ type: actionTypes.SET_BLOGS, payload: [] });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Blogs Saga Error ::: ", error);
    }
};

function* getBlogById(action) {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const blogId = action.payload;
        const { data } = yield getAPI(get_blog_by_id(blogId));
        console.log("Get Blog By Id Saga Response ::: ", data);

        if (data?.status) {
            yield put({ type: actionTypes.SET_BLOG_BY_ID, payload: data?.result });
        } else {
            yield put({ type: actionTypes.SET_BLOG_BY_ID, payload: null });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Blog By Id Saga Error ::: ", error);
    }
};

function* getCommunityMembers() {
    try {
        const { data } = yield getAPI(get_community_members);
        if (data?.status) {
            yield put({ type: actionTypes.SET_COMMUNITY_MEMBERS, payload: data?.result });
        } else {
            yield put({ type: actionTypes.SET_COMMUNITY_MEMBERS, payload: [] });
        }
    } catch (error) {
        console.log("Get Community Members Saga Error ::: ", error);
    }
};

export default function* webSaga() {
    yield takeLeading(actionTypes.GET_REPORTS, getReports);
    yield takeLeading(actionTypes.GET_SITE_SETTINGS, getSiteSettings);
    yield takeLeading(actionTypes.GET_AWARDS, getAwards);
    yield takeLeading(actionTypes.GET_MEDIA_COVERAGE, getMediaCoverage);
    yield takeLeading(actionTypes.GET_TESTIMONIAL_VIDEOS, getTestimonialVideos);
    yield takeLeading(actionTypes.GET_BLOGS, getBlogs);
    yield takeLeading(actionTypes.GET_BLOG_BY_ID, getBlogById);
    yield takeLeading(actionTypes.GET_COMMUNITY_MEMBERS, getCommunityMembers);
};
